import React, { useMemo } from 'react';
var WebpImage = function (_a) {
    var urlWebp = _a.urlWebp, children = _a.children;
    var isSvg = useMemo(function () {
        var _a;
        var image = (_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.src;
        if (image) {
            var extension = image.split('.').pop();
            return extension === 'svg';
        }
        return false;
    }, [children]);
    return (urlWebp && !isSvg)
        ? <picture draggable={false}>
            <source srcSet={urlWebp} type='image/webp'/>
            {children}
        </picture>
        : <>{children}</>;
};
export default WebpImage;
